import * as types from './mutation-types'
import shop from '../api/shop'

export const addToCart = ({ commit }, product) => {
    commit(types.ADD_TO_CART, {
      id: product._id,
      name: product.name,
      spec: product.spec,
      unit: product.unit,
      unit2: product.unit2,
      suppliers: product.suppliers,
    })
}

export const alertSpec = ({ commit }, product) => {
  commit(types.ALTER_SPEC, {
    id: product._id,
    name: product.name,
    spec: product.spec
  })
}

export const alertUnit = ({ commit }, product) => {
  commit(types.ALTER_UNIT, {
    id: product._id,
    name: product.name,
    unit2: product.unit2
  })
}

export const removeFromCart = ({ commit }, product) => {
	commit(types.REMOVE_FROME_CART,{
    id: product._id,
    spec: product.spec
	})
}

export const alterNum = ({ commit }, product) => {
  let num = event.target.value;
  num = Math.floor(num);
  if(num < 0){
    num = 0;
  }
  if(num > 999){
    num = 999;
  }
  commit(types.ALTER_NUM,{
    id: product._id,
    spec: product.spec,
    num,
	})
}




// WEBPACK FOOTER //
// ./src/store/actions.js